import { Button, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";

// helpers
const formatNumber = (v) =>
  Number(v || 0).toLocaleString("es-CO", { maximumFractionDigits: 0 });

const formatCurrency = (v) =>
  `$${Number(v || 0).toLocaleString("es-CO", { maximumFractionDigits: 0 })}`;

export default function ExportExcelButton({ data }) {
  const handleExport = async () => {
    try {
      if (!data || data.length === 0) {
        message.warning("No hay datos para exportar");
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet("Productos");

      sheet.columns = [
        { header: "PO", key: "Numero_PO", width: 12 },
        { header: "Producto", key: "nombre_producto", width: 40 },
        { header: "Municipio", key: "municipio", width: 20 },
        { header: "Proyecto", key: "codigo_proyecto", width: 15 },
        { header: "Cantidad", key: "cantidad_total", width: 15 },
        { header: "Valor Unitario", key: "valor_unitario_COP", width: 18 },
        { header: "Valor Total", key: "valor_total", width: 18 },
        { header: "% Entrega", key: "porcentaje_entrega", width: 15 },
        { header: "Estado", key: "estado", width: 15 }
      ];

      data.forEach(p => {
        sheet.addRow({
          Numero_PO: p.Numero_PO,
          nombre_producto: p.nombre_producto,
          municipio: p.municipio,
          codigo_proyecto: p.codigo_proyecto,
          cantidad_total: formatNumber(p.cantidad_total),
          valor_unitario_COP: formatCurrency(p.valor_unitario_COP),
          valor_total: formatCurrency(p.valor_total),
          porcentaje_entrega: `${formatNumber(p.porcentaje_entrega)}%`,
          estado: p.estado
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();

      saveAs(
        new Blob([buffer]),
        `productos_${new Date().toISOString().split("T")[0]}.xlsx`
      );

      message.success("Excel generado correctamente");

    } catch (error) {
      console.error(error);
      message.error("Error generando Excel");
    }
  };

  return (
    <Button
      icon={<DownloadOutlined />}
      type="primary"
      onClick={handleExport}
    >
      Exportar Excel
    </Button>
  );
}